enum TokenFieldAlias {
  id = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier',
  name = 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name',
  role = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role',
}

export default TokenFieldAlias;
